import { XStack, YStack, View, Text } from "tamagui";
import { colors } from "@styles/colors";

interface ToggleRowProps {
  icon?: React.ReactNode;
  iconColor?: string;
  label: string;
  sub?: string;
  value: boolean;
  onChange: (v: boolean) => void;
  accentColor?: string;
  isLast?: boolean;
}

/** icon + 文案 + 開關，用於偏好設定區塊 */
export default function ToggleRow({ icon, iconColor = colors.primary, label, sub, value, onChange, accentColor = colors.primary, isLast }: ToggleRowProps) {
  return (
    <XStack ai="center" gap="$3" px="$4" py="$3" bbw={isLast ? 0 : 1} bbc={colors.borderLight}>
      {icon && (
        <View w={32} h={32} br={8} bg={`${iconColor}15`} ai="center" jc="center" flexShrink={0}>
          {icon}
        </View>
      )}
      <YStack f={1} miw={0}>
        <Text fontSize={14} fontWeight="600" color={colors.text}>
          {label}
        </Text>
        {sub && (
          <Text fontSize={11} color={colors.hint} mt="$1">
            {sub}
          </Text>
        )}
      </YStack>
      <View
        w={44}
        h={26}
        br={13}
        bg={value ? accentColor : colors.gray100}
        position="relative"
        cursor="pointer"
        flexShrink={0}
        role="switch"
        aria-checked={value}
        aria-label={label}
        onPress={() => onChange(!value)}
        style={{ transition: "background 0.2s" }}>
        <View
          w={22}
          h={22}
          br={11}
          bg={colors.light}
          position="absolute"
          t={2}
          l={value ? 20 : 2}
          style={{ transition: "left 0.2s", boxShadow: "0 2px 4px rgba(0,0,0,0.15)" }}
        />
      </View>
    </XStack>
  );
}
